export enum ChartPeriod {
    TODAY,
    THIS_WEEK,
    LAST_WEEK,
    THIS_MONTH,
    THIS_YEAR,
    LAST_YEAR,
    CUSTOM,
    YESTERDAY

}
